module.exports = __webpack_public_path__ + "img/org6.1712a8e2.png";